module.exports = __webpack_public_path__ + "static/media/img-121.795b2438.jpg";